import { useNavigate } from "react-router-dom"
import { FileQuestion } from "lucide-react"
import { DashboardHeader } from "@/components/shared/dashboard-header"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <>
      <DashboardHeader />
      <main className="container mx-auto px-4 py-6 flex items-center justify-center min-h-[calc(100vh-4rem)]">
        <Card className="bg-card border-border max-w-md w-full">
          <CardContent className="flex flex-col items-center justify-center py-16 px-6">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted/50 mb-6">
              <FileQuestion className="h-10 w-10 text-muted-foreground" />
            </div>
            <h1 className="text-2xl font-semibold text-foreground mb-2">Page not found</h1>
            <p className="text-sm text-muted-foreground mb-8 text-center">
              The page you&apos;re looking for doesn&apos;t exist or has been moved.
            </p>
            <Button
              onClick={() => navigate("/")}
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              Back to Clients
            </Button>
          </CardContent>
        </Card>
      </main>
    </>
  )
}
